import {PdfEditorType} from "../enums/pdf-editor-type";

export class PdfEditor {
  public type: PdfEditorType;
  public text: string;
  public allowEditing: boolean;

  constructor(type: PdfEditorType, text: string, allowEditing = false) {
    this.type = type;
    this.text = text;
    this.allowEditing = allowEditing;
  }
}
